import { makeStyles, Theme } from "@material-ui/core";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";
import styled from "styled-components";

export const EmptyTableContent = styled("h3")<{ color?: string }>`
  padding: 3rem 1rem;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;

export const EmptyText = styled("h3")<{ color?: string }>`
  padding: 1rem 1rem;
  border-radius: 4px;
  text-align: center;
  width: 20%;
  margin: 0 auto;
  font-size: 1rem;
  margin-top: 30px;
  font-weight: bold;
  color: ${(p) => p.color || "#959595"};

  .highlighted {
    font-weight: 600;
    color: initial;
  }
`;

export interface StyleProps {
  color?: string;
}

export const useTableStyles = makeStyles<Theme, StyleProps>({
  countTotal: {
    "& .MuiTablePagination-caption": {},
    "& .MuiTablePagination-input": {
      color: "#399ebf",
    },
    "& .MuiSelect-icon": {
      color: "#399ebf",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      border: "solid 0.5px",
      borderRadius: "4px",
    },
  },
  KeyboardArrowLeft: {
    color: "#399ebf",
  },
  KeyboardArrowRight: {
    color: "#399ebf",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  tableRow: {
    width: "100%",
    borderCollapse: "separate",
    borderVerticalSpacing: "10px",
    background: "#ffff",
    paddingLeft: "15px",
  },
  rowRoot: {
    "& .MuiTableCell-head": {
      color: "#399ebf",
      backgroundColor: "#e2f4fb",
    },
  },
  tableCels: {
    "& .MuiTableCell-root:first-child": {
      border: "1.5px solid #E2F4FB",
      borderRight: "none",
      borderRadius: "5px 0px 0px 5px",
      marginTop: "5px",
      borderLeft: ({ color }) => `8px solid ${color} !important`,
    },
    "& .MuiTableCell-root:last-child": {
      border: "1.5px solid #E2F4FB",
      borderLeft: "none",
      borderRadius: "0px 5px 5px 0px",
    },
    "& .MuiTableCell-root": {
      border: "1.5px solid #E2F4FB",
      borderLeft: "none",
      borderRight: "none",
      backgroundColor: "#fff",
      marginTop: 5,
    },
  },
  numberOfParcels: {
    height: 5,
    borderRadius: "50%",
    background: "rgba(226, 202, 184, 0.56)",
    absolue: "relative",
    fontSize: 12,
    fontWeight: "bolder",
    color: "#f2994a",
  },
  buttonMenu: {
    width: 105,
    height: 29,
    backgroundColor: "#F2994A",
    color: "#fff",
    marginRight: 10,
  },
  spanStyled: {
    color: COLORS.primary,
    backgroundColor: "rgba(64, 180, 229, 0.15)",
    borderRadius: "4px",
    padding: "7px",
    width: "9rem",
    marginLeft: "30rem"
  },
});
